// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_lf0a1_12 {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._kbd_lf0a1_20 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  padding-inline: calc(2 * var(--default-grid-baseline)) calc(2 * var(--default-grid-baseline));
  border: 2px solid var(--color-primary-element-light);
  border-block-end-width: 4px;
  border-radius: var(--border-radius-element);
  box-shadow: none; /* Override server <kbd> styles */
  font-family: var(--font-family); /* Design decision: looks better with the default font instead of mono */
  line-height: 1;
  white-space: nowrap;
}
._kbd_lf0a1_20 + ._kbd_lf0a1_20 {
  margin-inline-start: calc(1 * var(--default-grid-baseline));
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcKbd-BGW1_Jb7.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,qCAAqC;EACrC,6FAA6F;EAC7F,oDAAoD;EACpD,2BAA2B;EAC3B,2CAA2C;EAC3C,gBAAgB,EAAE,iCAAiC;EACnD,+BAA+B,EAAE,wEAAwE;EACzG,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,2DAA2D;AAC7D","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_lf0a1_12 {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._kbd_lf0a1_20 {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  padding-inline: calc(2 * var(--default-grid-baseline)) calc(2 * var(--default-grid-baseline));\n  border: 2px solid var(--color-primary-element-light);\n  border-block-end-width: 4px;\n  border-radius: var(--border-radius-element);\n  box-shadow: none; /* Override server <kbd> styles */\n  font-family: var(--font-family); /* Design decision: looks better with the default font instead of mono */\n  line-height: 1;\n  white-space: nowrap;\n}\n._kbd_lf0a1_20 + ._kbd_lf0a1_20 {\n  margin-inline-start: calc(1 * var(--default-grid-baseline));\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
